export class EmployerFilter  {
    readonly EMPLOYER_SINGLE: string = "1";
    readonly EMPLOYER_MULTIPLE: string = "2";
    readonly EMPLOYER_MULTI: string = "3";
    readonly EMPLOYER_DFE_MASTER: string = "4";
    readonly EMPLOYER_DFE_UNABLE: string = "5";
    readonly EMPLOYER_DFE_GROUP: string = "6";
    readonly EMPLOYER_DFE_103: string = "7";
    readonly EMPLOYER_DFE_COM: string = "8";
    readonly EMPLOYER_DFE_POOLED: string = "9";
    readonly EMPLOYER_DFE_DCG: string = "10";
    readonly EMPLOYER_DFE_ALL: string = "[4 TO 10]";
    readonly EMPLOYER_NO_ENTRY: string = "99";
}